import {
    blueGrey500,
    blueGrey700,
    grey100,
    grey300,
    grey400,
    grey500,
    grey600,
    grey900,
    red700,
    green400,
    white,
} from 'material-ui/styles/colors';
import {fade} from 'material-ui/utils/colorManipulator';
import spacing from 'material-ui/styles/spacing';

export default {
    spacing: spacing,
    fontFamily: 'Roboto, sans-serif',
    palette: {
        primary1Color: blueGrey500, // #607d8b
        primary2Color: blueGrey700, // #455a64
        primary3Color: grey400, // #bdbdbd
        accent1Color: red700, // #d32f2f
        accent2Color: grey100, // #f5f5f5
        accent3Color: grey500, // #9e9e9e
        textColor: grey900, // #212121
        alternateTextColor: white, // #ffffff
        canvasColor: white, // #ffffff
        contentCanvasColor: '#edecec',
        lightCanvasColor: 'rgba(255,255,255,0.3)',
        borderColor: grey300, // #e0e0e0
        lightTextColor: fade(grey900, 0.5), // #212121
        disabledColor: fade(grey900, 0.3), // #212121
        pickerHeaderColor: blueGrey500, // #607d8b
        avatarColor: grey600, // #757575
        clockCircleColor: fade(grey900, 0.07), // #212121
        shadowColor: grey900, // #212121
        correctColor: green400, // #66bb6a
        errorColor: '#f44336',
    },
};


// WEBPACK FOOTER //
// ./src/Fuse/global/theme.js